<div class="toggle-tooltip-container">
  <mat-slide-toggle
    [id]="id"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabIndex]="to.tabindex"
    [labelPosition]="to.labelPosition">
    <span class="toggle-label-with-icon">
      {{ to.label }}
      <mat-icon
        *ngIf="to.tooltipText"
        class="tooltip-icon" 
        [matTooltip]="to.tooltipText"
        [matTooltipPosition]="to.tooltipPosition">
        {{ to.tooltipIcon }}
      </mat-icon>
    </span>
  </mat-slide-toggle>
</div>
